import { useStore } from './StoreContext'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Store } from 'lucide-react'

export function StoreSwitcher() {
  const { stores, currentStore, switchStore } = useStore()

  return (
    <Select value={currentStore?.id || ''} onValueChange={switchStore}>
      <SelectTrigger className="w-full">
        <div className="flex items-center gap-2">
          <Store className="h-4 w-4" />
          <SelectValue placeholder="Select store" />
        </div>
      </SelectTrigger>
      <SelectContent>
        {stores.map((store) => (
          <SelectItem key={store.id} value={store.id}>
            <div className="flex flex-col">
              <span className="font-medium">{store.name}</span>
              <span className="text-xs text-muted-foreground capitalize">{store.plan}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
